import React, { Component } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import ActionType from '../../../redux/reducer/globalActionType';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import IssueCategoryMenu from '../../../components/Settings/IssueCategoryMenu';
import IconAddTransparent from '../../../assets/icons/IconAddTransparent';
import IconActionEditBlue from '../../../assets/icons/IconActionEditBlue';
import IconActionDeleteBlue from '../../../assets/icons/IconActionDeleteBlue';
import ButtonBorderNexcareDefault from '../../../components/Button/ButtonBorderNexcareDefault';
import ButtonNexcareDefault from '../../../components/Button/ButtonNexcareDefault';
import TableNexcare from '../../../components/Table/TableNexcare';
import API_ISSUE_CATEGORY from '../../../api/apiIssueCategory';
import Alert from '../../../components/Alert/Alert';
import Mandatory from '../../../components/Common/Mandatory';
import MandatoryAlert from '../../../components/Common/MandatoryAlert';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    SETTING_ISSUE_CATEGORY_DELETE,
    SETTING_ISSUE_CATEGORY_INSERT,
    SETTING_ISSUE_CATEGORY_UPDATE,
    SETTING_ISSUE_CATEGORY_VIEW
} from '../../../constants/menuPermissionConstant';

class Module extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            columns: [
                {
                    title: "Modul",
                    dataIndex: "complaint_category",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    width: "w-1/12",
                    render: (data) => (
                        <div className="flex items-center space-x-3">
                            <CheckPermissionComponent permissionConstant={[SETTING_ISSUE_CATEGORY_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btnedit" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showEditModal: true, moduleDataSelectedEdit: data, module: data.complaint_category })}>
                                    <IconActionEditBlue />
                                </div>
                            </CheckPermissionComponent>
                            <CheckPermissionComponent permissionConstant={[SETTING_ISSUE_CATEGORY_DELETE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btndelete" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showConfirmDeleteAlert: true, moduleDataSelectedDelete: data })}>
                                    <IconActionDeleteBlue />
                                </div>
                            </CheckPermissionComponent>
                        </div>
                    ),
                },
            ],
            productOptions: {
                data: [],
                value: [],
            },
            disableButtonAddAndSave: true,
            listModule: [],
            module: '',
            moduleDataSelectedEdit: {},
            moduleDataSelectedDelete: {},
            showAddModal: false,
            showEditModal: false,
            showWarningModule: false,
            showConfirmAddAlert: false,
            showSuccessAddAlert: false,
            showConfirmEditAlert: false,
            showSuccessEditAlert: false,
            showConfirmDeleteAlert: false,
            showSuccessDeleteAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                this.getInitiateModule(this.state.productOptions.value.value);
                this.getListModule(this.state.productOptions.value.value, this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                this.getInitiateModule(this.state.productOptions.value.value);
                this.getListModule(this.state.productOptions.value.value, this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    }

    handleChangeProduct = e => {
        this.setState({
            productOptions: { ...this.state.productOptions, value: e },
            disableButtonAddAndSave: false
        }, () => {
            this.getInitiateModule(this.state.productOptions.value.value);
            this.getListModule(this.state.productOptions.value.value, this.state.pagination.current, this.state.pagination.pageSize);
        });
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    getListProduct = (current, pageSize) => {
        API_ISSUE_CATEGORY.getListProduct(current, pageSize, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let tempModules = getContent(res).map(moduleDetail => ({
                        value: moduleDetail.id,
                        label: moduleDetail.complaint_description
                    }));
                    this.setState({ productOptions: { ...this.state.productOptions, data: tempModules } });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getInitiateModule = productId => {
        API_ISSUE_CATEGORY.getInitiateModule(productId, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: { ...this.state.pagination, total: getContent(res).count_data }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListModule = (productId, current, pageSize) => {
        API_ISSUE_CATEGORY.getListModule(productId, current, pageSize, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        listModule: getContent(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleCancelButton = () => {
        this.setState({
            showAddModal: false,
            showEditModal: false,
            showWarningModule: false,
            module: ''
        });
    }

    handleConfirmAddModule = () => {
        if (!this.state.module) return this.setState({ showWarningModule: true });
        this.setState({ showConfirmAddAlert: true });
    }

    handleAddModule = () => {
        const data = {
            complaint_category: this.state.module,
            complaint_id: this.state.productOptions.value.value
        }

        API_ISSUE_CATEGORY.postDataModule(data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showAddModal: false,
                        showConfirmAddAlert: false,
                        showSuccessAddAlert: true,
                        module: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmAddAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessAddModule = () => {
        this.setState({
            showSuccessAddAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateModule(this.state.productOptions.value.value);
            this.getListModule(this.state.productOptions.value.value, this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleConfirmEditModule = () => {
        if (!this.state.module) return this.setState({ showWarningModule: true });
        this.setState({ showConfirmEditAlert: true });
    }

    handleEditModule = () => {
        const moduleId = this.state.moduleDataSelectedEdit.id;
        const data = {
            complaint_category: this.state.module,
            complaint_id: this.state.productOptions.value.value,
            updated_at: this.state.moduleDataSelectedEdit.updated_at
        }

        API_ISSUE_CATEGORY.putDataModule(moduleId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showEditModal: false,
                        showConfirmEditAlert: false,
                        showSuccessEditAlert: true,
                        module: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmEditAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessEditModule = () => {
        this.setState({
            showSuccessEditAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateModule(this.state.productOptions.value.value);
            this.getListModule(this.state.productOptions.value.value, this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleDeleteModule = () => {
        this.setState({ showConfirmDeleteAlert: false });

        const moduleId = this.state.moduleDataSelectedDelete.id;
        const data = {
            updated_at: this.state.moduleDataSelectedDelete.updated_at
        }
        API_ISSUE_CATEGORY.deleteDataModule(moduleId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({ showSuccessDeleteAlert: true });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessDeleteModule = () => {
        this.setState({
            showSuccessDeleteAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateModule(this.state.productOptions.value.value);
            this.getListModule(this.state.productOptions.value.value, this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getListProduct(1, 100);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[SETTING_ISSUE_CATEGORY_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="h-full pb-5">
                    {/* Breadcrumbs */}
                    <BreadCrumbs
                        parentMenu="Pengaturan"
                        serviceMenu="Kategori Masalah"
                        title="Modul"
                    />

                    {/* White Container */}
                    <div className="h-content">
                        {/* Content */}
                        <div className="calculate-layout-blank bg-white border border-gray-300 rounded-lg px-6 py-10 space-y-10 overflow-auto">
                            {/* Menu */}
                            <IssueCategoryMenu />

                            <div className="space-y-4">
                                {/* Filter by Product */}
                                <div className="w-1/4 space-y-1">
                                    <div className="flex font-bold">
                                        <p className="mr-1">Produk</p>
                                    </div>
                                    <Select
                                        inputId="ddsproduct"
                                        name="product"
                                        options={this.state.productOptions.data}
                                        value={this.state.productOptions.value}
                                        placeholder="Pilih Produk"
                                        components={{ IndicatorSeparator: () => null }}
                                        className="w-full"
                                        onChange={this.handleChangeProduct}
                                    />
                                </div>

                                {/* Add Module Button */}
                                <CheckPermissionComponent permissionConstant={[SETTING_ISSUE_CATEGORY_INSERT]} userPermission={this.props.userDetail.permissions}>
                                    <button id="btnaddmodule" onClick={() => this.setState({ showAddModal: true })} className={`flex items-center text-white py-2 px-6 rounded-md ${this.state.disableButtonAddAndSave ? "bg-gray-500 cursor-default" : "bg-olddarkblue cursor-pointer"}`} disabled={this.state.disableButtonAddAndSave}>
                                        <IconAddTransparent />
                                        <span className="ml-2">Modul</span>
                                    </button>
                                </CheckPermissionComponent>

                                {/* Table Module */}
                                <div className={this.state.productOptions.value.value ? "block" : "hidden"}>
                                    <TableNexcare
                                        column={this.state.columns}
                                        dataTable={this.state.listModule}
                                        pagination={this.state.pagination}
                                        onPage={this.handleSelectedPage}
                                        onPageSize={this.handleSelectedPageSize}
                                        halfBodyHeight
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Add Module Modal */}
                    <div className={this.state.showAddModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Tambah Modul</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Modul <Mandatory /></p>
                                    <input
                                        type="text"
                                        id="tslmoduleadd"
                                        className="form-control"
                                        placeholder="Tulis Modul"
                                        name="module"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningModule: false });
                                        }}
                                        minLength="3"
                                        maxLength="30"
                                        autoComplete="off"
                                        value={this.state.module}
                                    />
                                    {this.state.showWarningModule && <MandatoryAlert text="Modul tidak boleh kosong!" />}
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btnaddmodule" onClick={this.handleConfirmAddModule}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Edit Module Modal */}
                    <div className={this.state.showEditModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Ubah Modul</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Modul <Mandatory /></p>
                                    <input
                                        type="text"
                                        id="tslmoduleedit"
                                        className="form-control"
                                        placeholder="Tulis Modul"
                                        name="module"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningModule: false });
                                        }}
                                        minLength="3"
                                        maxLength="30"
                                        autoComplete="off"
                                        value={this.state.module}
                                    />
                                    {this.state.showWarningModule && <MandatoryAlert text="Modul tidak boleh kosong!" />}
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btneditmodule" onClick={this.handleConfirmEditModule}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Alert */}
                    <Alert show={this.state.showConfirmAddAlert} button title="Simpan Modul" desc="Apakah Anda yakin ingin menyimpan data?" close={() => this.setState({ showConfirmAddAlert: false })} submit={this.handleAddModule} />
                    <Alert show={this.state.showSuccessAddAlert} icon="success" title="Berhasil" desc="Data berhasil disimpan" close={this.handleSuccessAddModule} ok />
                    <Alert show={this.state.showConfirmEditAlert} button title="Simpan Modul" desc="Apakah Anda yakin ingin mengubah data?" close={() => this.setState({ showConfirmEditAlert: false })} submit={this.handleEditModule} />
                    <Alert show={this.state.showSuccessEditAlert} icon="success" title="Berhasil" desc="Data berhasil diubah" close={this.handleSuccessEditModule} ok />
                    <Alert show={this.state.showConfirmDeleteAlert} button title="Hapus Modul" desc="Apakah Anda yakin ingin menghapus data?" close={() => this.setState({ showConfirmDeleteAlert: false, moduleDataSelectedDelete: {} })} submit={this.handleDeleteModule} />
                    <Alert show={this.state.showSuccessDeleteAlert} icon="success" title="Berhasil" desc="Data berhasil dihapus" close={this.handleSuccessDeleteModule} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Module);